import { adSlotSizes, pubPageAdTargeting } from "@config/AdsConstants";
import CompanionAdvertisement from "@elements/Advertisement/CompanionAdvertisement";
import { GoogleAdsSlotFactory } from "@elements/Advertisement/helpers";
import {
  AdTargetingType,
  AdvertisementTypeEnum,
  ArticleAdSlotTargetingType,
  PageAdTargetValue,
} from "@typings/Ads.d";
import { twMerge } from "tailwind-merge";

type aiSummaryAdPros = {
  /**
   * Unique section name used to generate the Google Ads slot.
   */
  uniqueSectionName?: string;

  /**
   * Index of the ad placement on the page.
   */
  index: number;

  /**
   * Additional CSS classes to apply to the ad wrapper.
   */
  wrapperStyle?: string;

  /**
   * Google ad channels used for ad targeting.
   */
  gsChannels?: string[];

  /**
   * Page-level ad targeting type.
   */
  pageAdTargetType: PageAdTargetValue;

  /**
   * Article-level ad targeting values.
   */
  articleSlotTarget?: ArticleAdSlotTargetingType[];

  /**
   * Determines whether the default ad slot should be overridden.
   */
  overRideSlot?: boolean;

  /**
   * Additional CSS classes for advertisement element.
   */
  rootClassName?: string;
};

/**
 * Renders the LB2 advertisement for the AI summary section.
 *
 * Configures and renders a companion advertisement using the LB2 AI Summary
 * advertisement type and the provided page and article targeting values.
 *
 * @param props - Props used to configure the AI summary advertisement.
 * @returns The LB2 AI summary advertisement.
 */
export function AISummaryAdsLb({
  uniqueSectionName,
  index,
  gsChannels,
  pageAdTargetType,
  rootClassName,
  articleSlotTarget,
  wrapperStyle,
}: aiSummaryAdPros) {
  const pubPageAdTarget = pubPageAdTargeting[
    pageAdTargetType
  ] as AdTargetingType<PageAdTargetValue>;
  return (
    <div
      className={twMerge(
        "flex items-center justify-center w-full",
        wrapperStyle,
      )}
    >
      <CompanionAdvertisement
        companionAdUnitProps={{
          type: AdvertisementTypeEnum.LB2AISUMMARY,
          slot: GoogleAdsSlotFactory.lb2(uniqueSectionName),
          id:
            index === 0
              ? "dfp-ad-lb2-aisummary"
              : `dfp-ad-imu1-aisummary-${index}`,
          rootClassName: rootClassName ? rootClassName : "m-0",
          pageNumber: index.toString(),
          gsChannels,
          articleSlotTarget,
          adSlotSize: adSlotSizes["lb2AiSummary"],
          pubAdTargeting: [pubPageAdTarget],
        }}
      />
    </div>
  );
}
